export default `
  query soClozScript($product_id: Int) {
    reservationButton(product_id: $product_id) {
      html
    }
  }
`;
